module.exports = __webpack_public_path__ + "img/ROnager64_ua.8c4888c5.webp";